import Head from 'next/head';

import { createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, RouterLink, Flex, DocumentTitle } = shared;
import Meta from '@lib/components/head/Meta';

import styles from './index.module.scss';
import DefaultLayout from '@/layouts/DefaultLayout';

export default createPage('Contact', { styles }, function Contact({ className }) {
  const faqs = [
    { question: 'What are io games?', answer: 'IO or .io games are HTML5 multiplayer games that require no login or sign up and are easy to get into.' },
    { question: 'How do I get my game featured?', answer: 'Check out our page feature our your IO game page.' },
    { question: 'Why create the list of top IO games?', answer: 'After we found the first few popular io games, we tried to find more. Sadly, without a list, they were really hard to find. We felt that they deserved more exposure, so we decided to create our own list. We put together all the titles we could find, and many helpful users shared new ones with us. From that point on, we were on a mission to push the io movement forward!' },
    { question: 'History of IO Games', answer: 'The io game genre all began with the release of an insanely addicting game called agar.io (which was probably inspired by another game called "Osmos"). Agario grew so fast that within months, it was already seeing several hundred thousand players worldwide. What made this io game so unique was it’s a very interesting style. Unlike most browser games of the past, it was designed to be played in a full-screen browser window and was entirely multiplayer. This set the framework for many of the other .io games that would hit the web in the months to come.' }
  ];

  const breadcrumbs = [
    { url: `${process.env.APP_CONFIG.URL}/popular`, name: 'Popular io Games' }
  ];

  return (
    <>
      <DocumentTitle title='Contact Us' />

      <Meta>
        <script 
            type='application/ld+json' 
            dangerouslySetInnerHTML={{ 
              __html: JSON.stringify({
                "@context": "http://schema.org/",
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "What are io games?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "IO or .io games are HTML5 multiplayer games that require no login or sign up and are easy to get into."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How do I get my game featured?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Check out our page feature our your IO game page."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Why create the list of top IO games?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "After we found the first few popular io games, we tried to find more. Sadly, without a list, they were really hard to find. We felt that they deserved more exposure, so we decided to create our own list. We put together all the titles we could find, and many helpful users shared new ones with us. From that point on, we were on a mission to push the io movement forward!"
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "History of IO Games",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "The io game genre all began with the release of an insanely addicting game called agar.io (which was probably inspired by another game called \"Osmos\"). Agario grew so fast that within months, it was already seeing several hundred thousand players worldwide. What made this io game so unique was it’s a very interesting style. Unlike most browser games of the past, it was designed to be played in a full-screen browser window and was entirely multiplayer. This set the framework for many of the other .io games that would hit the web in the months to come."
                    }
                  }
                ]
              }, null, 2)
            }}
        />
        <script 
            type='application/ld+json' 
            dangerouslySetInnerHTML={{ 
              __html: JSON.stringify({
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "item": {
                      "@id": process.env.APP_CONFIG.URL,
                      "name": process.env.APP_CONFIG.DEFAULT_TITLE
                    }
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "item": {
                      "@id":process.env.APP_CONFIG.URL+'/contact-us',
                      "name": "Contact IO Games"
                    }
                  }
                ],
              }, null, 2)
            }}
        />
      </Meta>

      <DefaultLayout className={className}>
        <Box>
          <Block>
            <Title size3>Need some help?</Title>
            <p>
              Check out our frequently asked questions or <RouterLink href='mailto:contact@iogames.space'>contact us any time here.</RouterLink>
            </p>
          </Block>

          <hr />

          <Block>
            <Title size3>Frequently asked questions</Title>

            <Block>
              <Title size5>How do I get my game featured?</Title>
              <RouterLink href='/feature-your-io-game'>
                Check out our page feature our your IO game page
              </RouterLink>
            </Block>

            <Flex directionColumn fourFifths center>
              <Title size5>Why create the list of top IO games?</Title> 
              <Block>
                <p>
                  After we found the first few popular <RouterLink href='/'>io games</RouterLink>, we tried to find more. Sadly, without a list, they were really hard to find. We felt that they deserved more exposure, so we decided to create our own list. We put together all the titles we could find, and many helpful users shared new ones with us. From that point on, we were on a mission to push the io movement forward!
                </p>
              </Block>
              <Block>
                <p>
                  On this site, you will find that the games in the list have a common style and theme similar to those mentioned above. The goal of the list is to bring exposure to these awesome .io games that oftentimes go unnoticed. This is due to the fact that they are all standalone games which means that they are all hosted on separate sites. That’s what we're here for! So, support the games and make sure you bookmark this site. (CTRL-D) We try to keep it updated with the best, new io games every day, so make sure to check back from time to time. Have fun!
                </p>
              </Block>
            </Flex>
          </Block>

          <hr />

          <Block>
            <Title size3>History of IO Games</Title>
            <p>
              The io game genre all began with the release of an insanely addicting game called agar.io (which was probably inspired by another game called “Osmos”). Agario grew so fast that within months, it was already seeing several hundred thousand players worldwide. What made this io game so unique was it’s a very interesting style. Unlike most browser games of the past, it was designed to be played in a full-screen browser window and was entirely multiplayer. This set the framework for many of the other .io games that would hit the web in the months to come.
            </p>
          </Block>
        </Box>
      </DefaultLayout>
    </>
  )
});